import script from "./ListOrden.vue?vue&type=script&setup=true&lang=js"
export * from "./ListOrden.vue?vue&type=script&setup=true&lang=js"

import "./ListOrden.vue?vue&type=style&index=0&id=b254d58a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b254d58a"]])

export default __exports__